export enum ImageFileExtension {
    PNG = 'png',
    JPG = 'jpg',
    JPEG = 'jpeg',
    WEBP = 'webp',
}

export enum VideoFileExtension {
    MP4 = 'mp4',
    AVI = 'avi',
    MKV = 'mkv',
    MOV = 'mov',
}

export enum AudioFileExtension {
    MP3 = 'mp3',
    WAV = 'wav',
    M4A = 'm4a',
    OGG = 'ogg',
}

/**
 * @see http://www.iana.org/assignments/media-types/media-types.xhtml
 */
export const ContentType: Record<
    ImageFileExtension | VideoFileExtension | AudioFileExtension,
    string
> = {
    // Images (image/*)
    [ImageFileExtension.PNG]: 'image/png',
    [ImageFileExtension.JPG]: 'image/jpeg',
    [ImageFileExtension.JPEG]: 'image/jpeg',
    [ImageFileExtension.WEBP]: 'image/webp',

    // Videos (video/*)
    [VideoFileExtension.MP4]: 'video/mp4',
    [VideoFileExtension.AVI]: 'video/avi',
    [VideoFileExtension.MKV]: 'video/matroska',
    [VideoFileExtension.MOV]: 'video/quicktime',

    // Audio (audio/*)
    [AudioFileExtension.MP3]: 'audio/mpeg',
    [AudioFileExtension.WAV]: 'audio/wav',
    [AudioFileExtension.M4A]: 'audio/mp4',
    [AudioFileExtension.OGG]: 'audio/ogg',
};
